<template>
  <span class="scaling-svg-container">
    <svg
      data-name="Icon/Arrowhead Right"
      xmlns="http://www.w3.org/2000/svg"
      width="14.375"
      height="14.376"
      viewBox="0 0 14.375 14.376"
      class="scaling-svg"
    >
      <path
        data-name="Icon/Icon/Arrowhead-right"
        d="M8.214,14.376a1.026,1.026,0,0,1-.788-1.684l4.6-5.515L7.591,1.671A1.027,1.027,0,0,1,9.192.383l4.957,6.16a1.029,1.029,0,0,1-.011,1.3L9,14.007A1.027,1.027,0,0,1,8.214,14.376Zm-7.188,0a1.026,1.026,0,0,1-.788-1.684l4.6-5.515L.4,1.671A1.028,1.028,0,0,1,.56.227,1.027,1.027,0,0,1,2,.383l4.958,6.16a1.032,1.032,0,0,1-.012,1.3L1.815,14.007A1.024,1.024,0,0,1,1.026,14.376Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ArrowDoubleRightIcon extends Vue {}
</script>

<style>
</style>
